export default {
  searching: 'Bezig met zoeken',
}
